export enum OneClickOrigin {
    CALCULADORA = 3
}
export enum OriginPayment {
    INT = 2
}
export enum SourceShoppingCart {
    NEW_CART = 4,
    CART_V3 = 5
}

export enum methodsName {
    PAYPAL = 'paypal',
    DINERO_MAIL = 'dinero_mail',
    CARD = 'tarjeta',
    CASH = 'efectivo',
    TRANSFER = 'transferencia',
    CARD_3DS = 'card_3ds',
    DIRECT = 'pago_directo',
}

export const payment_method: any = {
    [methodsName.PAYPAL]: 1,
    [methodsName.DINERO_MAIL]: 2,
    [methodsName.CARD]: 3,
    [methodsName.TRANSFER]: 4,
    [methodsName.CARD_3DS]: 5,
    [methodsName.CASH]: 6,
    [methodsName.DIRECT]: 8,
};

export const pyament_method_str = {
    [methodsName.PAYPAL]: "Paypal",
    [methodsName.DINERO_MAIL]: "Dinero Mail",
    [methodsName.CARD]: "Tarjeta",
    [methodsName.TRANSFER]: "Transferencia Bancaria",
    [methodsName.CARD_3DS]: "Tarjeta 3DS",
    [methodsName.CASH]: "Pago en Tienda",
    [methodsName.DIRECT]: "Pago directo",
};

/** Total del carrito (MXN) por encima del cual Tarjeta y Pago en tienda no aplican. */
export const PAYMENT_MAX_AMOUNT_CARD_AND_STORE_MXN = 30000;

export const PAYMENT_METHOD_LIMIT_EXCEEDED_MESSAGE =
    'Método de pago no disponible para cantidades mayores o iguales a $30,000.00 MXN';

/** true si el método elegido no puede usarse con ese total (tarjeta / tienda y total > límite). */
export function isPaymentMethodDisallowedForTotal(methodValue: number | null, total: number): boolean {
    if (methodValue === null) return false;
    if (total <= PAYMENT_MAX_AMOUNT_CARD_AND_STORE_MXN) return false;
    return (
        methodValue === payment_method[methodsName.CARD] ||
        methodValue === payment_method[methodsName.CASH]
    );
}
